import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { KBHeader } from '../components/KBHeader';
import { KBSidebar } from '../components/KBSidebar';
import { SearchResults } from '../components/SearchResults';
import { useSearch } from '../hooks/useSearch';
import { useKBTheme } from '../hooks/useKBTheme';
import { articles } from '../data/articles';

export const SearchPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const { results, addRecentSearch } = useSearch(articles, query);
  const { mode } = useKBTheme();

  useEffect(() => {
    if (query) {
      addRecentSearch(query);
    }
  }, [query, addRecentSearch]);

  const getBackgroundGradient = () => {
    if (mode === 'dark') {
      return 'linear-gradient(180deg, #0f172a 0%, #151b26 25%, #1a2332 50%, #1c2838 75%, #1e293b 100%)';
    }
    return 'linear-gradient(180deg, #FAFBFC 0%, #FAFAFC 25%, #F9FAFB 50%, #F9FAFC 75%, #F8FAFC 100%)';
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: getBackgroundGradient(),
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: mode === 'dark'
            ? `radial-gradient(circle at 20% 80%, rgba(99,102,241,0.08) 0%, transparent 50%),
               radial-gradient(circle at 80% 20%, rgba(236,72,153,0.08) 0%, transparent 50%)`
            : `radial-gradient(circle at 20% 80%, rgba(99, 102, 241, 0.05) 0%, transparent 50%),
               radial-gradient(circle at 80% 20%, rgba(236, 72, 153, 0.05) 0%, transparent 50%)`,
          pointerEvents: 'none',
        },
      }}
    >
      <KBHeader onSearch={() => {}} />
      <Box sx={{ display: 'flex', position: 'relative', zIndex: 1 }}>
        <KBSidebar />
        <Box sx={{ flex: 1, p: 4 }}>
          <Container maxWidth="xl" sx={{ px: 0 }}>
            <SearchResults results={results} query={query} />
          </Container>
        </Box>
      </Box>
    </Box>
  );
};








